const columns = [
  { title: 'STT', key: 'stt' },
  { title: 'Mã khách hàng', key: 'code' },
  { title: 'Tên khách hàng', key: 'name' },
  { title: 'Email', key: 'email' },
  { title: 'Liên hệ', key: 'phone' },
  { title: 'Tổng số đơn hàng', key: 'order_quantity' },
  { title: 'Ngày tạo', key: 'create_date' },
  { title: 'Ngày sinh', key: 'birthday' },
  { title: 'Thông tin xuất hoá đơn', key: 'invoice_info' },
  { title: 'Hành động', key: 'action' },
]

export default columns
